import React from 'react'
import { string, object } from 'prop-types'
import NumberFormat from 'react-number-format'

import Input from 'components/Input'

const NumberInput = ({ numberFormat, field, ...props }) => (
  <NumberFormat customInput={Input} format={numberFormat} {...field} {...props} />
)

NumberInput.propTypes = {
  numberFormat: string,
  field: object
}

export default NumberInput
